import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    height: '100%',
    width: '100%',
  },
  loadingContainer: {
    height: 150,
    width: '100%',
  },
  button: {
    fontSize: theme.typography.pxToRem(13),
    textTransform: 'capitalize',
  },
}));

export default useStyles;
